import _ from 'underscore';

/* global Map */

export function pairsToMap(pairs) {
  return _.reduce(pairs, (memo, [key, value]) => {
    memo.set(key, value);
    return memo;
  }, new Map());
}
